import { motion } from 'framer-motion';
import { Heart, Instagram, Leaf, Mail, Twitter, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';

const footerLinks = {
  product: [
    // { name: 'Features', href: '/features' },
    { name: 'Pricing', href: '/pricing' }
    // { name: 'API', href: '/api' },
    // { name: 'Download App', href: '/download' }
  ],
  company: [
    // { name: 'About Us', href: '/about' },
    // { name: 'Blog', href: '/blog' },
    // { name: 'Careers', href: '/careers' },
    { name: 'Help Center', href: '/help' }
  ],
  support: [
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Privacy Policy', href: '/privacy' }
    // { name: 'Cookie Policy', href: '/cookies' }
  ],
  social: [
    { name: 'Twitter', icon: Twitter, href: 'https://twitter.com/leaflens' },
    // { name: 'Facebook', icon: Facebook, href: 'https://facebook.com/leaflens' },
    {
      name: 'Instagram',
      icon: Instagram,
      href: 'https://instagram.com/leaflens'
    },
    {
      name: 'Youtube',
      icon: Youtube,
      href: 'https://youtube.com/company/leaflens'
    }
    // { name: 'GitHub', icon: Github, href: 'https://github.com/leaflens' }
  ]
};

function FooterSection({ title, links }) {
  return (
    <div>
      <h3 className="font-semibold text-gray-900 mb-4">{title}</h3>
      <ul className="space-y-3">
        {links.map(link => (
          <li key={link.name}>
            {link.href.startsWith('http') ? (
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-emerald-600 transition-colors"
              >
                {link.name}
              </a>
            ) : (
              <Link
                to={link.href}
                className="text-gray-600 hover:text-emerald-600 transition-colors"
              >
                {link.name}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="bg-white border-t border-gray-200"
    >
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Leaf className="w-6 h-6 text-emerald-600" />
              <span className="text-xl font-semibold text-gray-900">
                GreenLens
              </span>
            </Link>
            <p className="text-gray-600 mb-4">
              Identify any plant instantly using AI. Get detailed care
              instructions and grow your botanical knowledge.
            </p>
            <div className="flex gap-4">
              {footerLinks.social.map(social => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-emerald-600 transition-colors"
                  aria-label={social.name}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Links Sections */}
          <FooterSection title="Product" links={footerLinks.product} />
          <FooterSection title="Company" links={footerLinks.company} />
          <FooterSection title="Support" links={footerLinks.support} />
        </div>

        {/* Newsletter Section */}
        <div className="border-t border-gray-200 mt-12 pt-8">
          <div className="max-w-md">
            <h3 className="font-semibold text-gray-900 mb-2">
              Subscribe to our newsletter
            </h3>
            <p className="text-gray-600 mb-4">
              Get plant care tips, feature updates, and botanical insights
              delivered to your inbox.
            </p>
            <form className="flex gap-2">
              <div className="relative flex-1">
                <Mail className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="w-full pl-10 pr-3 py-2 border rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                />
              </div>
              <button
                type="submit"
                className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors flex-shrink-0"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <span>Made with</span>
            <Heart className="w-4 h-4 text-red-500 animate-pulse" />
            <span>For you</span>
          </div>
          <div className="text-sm text-gray-600">
            © {currentYear} GreenLens. All rights reserved.
          </div>
        </div>
      </div>
    </motion.footer>
  );
}
